import _get from 'lodash/get';
import {
  FilterGroupingEnum,
  TaskCompletionFilterInputObject,
} from 'graphql-common';
import { Option } from '@lib/interfaces/form';
import TaskCompletionsFilterFieldNames from '@lib/enums/fieldNames/taskCompletionsFilterFieldNames';
import { transformDate } from '@lib/utils/dateTimeHelpers';

type Args = {
  filterParams?: Record<string, unknown> | null;
  periodValue: string[];
};

export default function getTaskCompletionsFilters({
  filterParams,
  periodValue,
}: Args): TaskCompletionFilterInputObject[] {
  const filters: TaskCompletionFilterInputObject[] = [];

  const [periodStartRaw, periodEndRaw] = periodValue || [];

  if (periodStartRaw) {
    const periodStart = transformDate(new Date(periodStartRaw), false, true);
    filters.push({
      createdAt: {
        grouping: FilterGroupingEnum.And,
        predicate: { gteq: periodStart },
        filterGroup: 'createdAt',
      },
    });
  }

  if (periodEndRaw) {
    const periodEnd = transformDate(new Date(periodEndRaw), true);
    filters.push({
      createdAt: {
        grouping: FilterGroupingEnum.And,
        predicate: { lteq: periodEnd },
        filterGroup: 'createdAt',
      },
    });
  }

  const users =
    (_get(
      filterParams,
      TaskCompletionsFilterFieldNames.Users,
      [],
    ) as Option[]) || [];

  if (users.length) {
    filters.push({
      performerId: {
        grouping: FilterGroupingEnum.And,
        predicate: {
          in: users
            .map(({ value }) => value)
            .filter(Boolean)
            .map(String),
        },
        filterGroup: 'performerId',
      },
    });
  }

  const validityHints =
    (_get(
      filterParams,
      TaskCompletionsFilterFieldNames.ValidityHints,
      [],
    ) as Option[]) || [];

  if (validityHints.length) {
    filters.push({
      validityHint: {
        grouping: FilterGroupingEnum.And,
        predicate: {
          in: validityHints
            .map(({ value }) => value)
            .filter(Boolean)
            .map(String),
        },
        filterGroup: 'validityHint',
      },
    });
  }

  return filters;
}
